import { useState } from "react";
import { usernameGenerator } from "utils/strings";
import { AddDoctor, getDoctors } from "store/services/doctor.service";
import { useHistory } from "react-router-dom";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  Container,
  Spinner,
  Row,
  Col,
  FormFeedback,
} from "reactstrap";

import Header from "components/Headers/Header";
import { GET_DOCTORS } from "store/types";
import { useDispatch } from "react-redux";

const NewDoctor = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();

  // Input State
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [mobile, setMobile] = useState("");
  const [showSpinner, setShowSpinner] = useState(false);

  // Input Validation
  const [isName, setIsName] = useState(false);

  const addDoctor = () => {
    setShowSpinner(true);
    setIsName("Name can not be empty");

    const data = {
      username: usernameGenerator(name),
      email: email,
      password: password,
      role: "authenticated",
      name: name,
      mobile: mobile,
    };
    AddDoctor(data).then(() => {
      getDoctors().then((data) => {
        dispatch({ type: GET_DOCTORS, payload: data });
      });
      history.push("/admin/tables");
    });
  };

  return (
    <>
      <Header />
      {/* Page content */}
      <Container className="mt--9" fluid>
        <Row>
          <Col className="order-xl-1" xl="12">
            <Card className="bg-secondary shadow">
              <CardHeader className="bg-white border-0">
                <Row className="align-items-center">
                  <Col xs="8">
                    <h3 className="mb-0">New Doctor</h3>
                  </Col>
                  <Col className="text-right" xs="4">
                    {showSpinner ? (
                      <Spinner color="primary" type="grow" />
                    ) : (
                      <Button color="primary" onClick={addDoctor} size="sm">
                        ADD DOCTOR
                      </Button>
                    )}
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <Form>
                  <h6 className="heading-small text-muted mb-4">
                    Doctor information
                  </h6>
                  <div className="pl-lg-4">
                    <Row>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-username"
                          >
                            Name
                          </label>
                          <Input
                            className="form-control-alternative"
                            onChange={(e) => {
                              setName(e.target.value);
                              // setIsName(false);
                            }}
                            id="input-username"
                            placeholder="Doctor name"
                            type="text"
                            invalid={isName}
                          />
                        </FormGroup>
                        <FormFeedback>{isName}</FormFeedback>
                      </Col>

                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-first-name"
                          >
                            Email
                          </label>
                          <Input
                            onChange={(e) => setEmail(e.target.value)}
                            className="form-control-alternative"
                            id="input-first-name"
                            placeholder="example@example.com"
                            type="text"
                            invalid
                          />
                        </FormGroup>
                        <FormFeedback>dsadas</FormFeedback>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-email"
                          >
                            Doctor Number
                          </label>
                          <Input
                            onChange={(e) => setMobile(e.target.value)}
                            className="form-control-alternative"
                            id="input-email"
                            placeholder="07********"
                            type="text"
                          />
                        </FormGroup>
                      </Col>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-email"
                          >
                            Password
                          </label>
                          <Input
                            onChange={(e) => setPassword(e.target.value)}
                            className="form-control-alternative"
                            id="input-email"
                            placeholder="********"
                            type="password"
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </div>
                  <hr className="my-4" />
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default NewDoctor;
